import styled from "styled-components"
import React from 'react'

const SVG = styled.svg<{ size: number | string }>`
  --size: ${({ size }) => typeof size === 'string' ? size : (size + 'px')};
  width: var(--size);
  height: var(--size);
  fill: ${({ color, theme }) => color === 'theme' ? theme.colors.theme : (color ?? theme.colors.black)};
  overflow: hidden;
`
export interface IconProps {
  code: string
  className?: string
  color?: string
  size?: number | string
}

export const Icon: React.VFC<IconProps> = ({
  code,
  size = 16,
  ...restProps
}) => {
  return (
    <SVG data-testid={Icon.name} size={size} {...restProps}>
      <use href={`#icon-${code}`} />
    </SVG>
  )
}
